// src/routes/index.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeRoutes from "./HomeRoutes";
import WealthMethodRoutes from "./WealthMethodRoutes";
import UserRoutes from "./UserRoutes";

/**
 * Centralized application route groups.
 *
 * IMPORTANT:
 * - The WealthMethodRoutes are mounted at "/wealth-method/*".
 * - HomeRoutes is mounted at the root "/*" so it handles all top-level pages.
 *
 * Order is important: more specific route groups should be defined above more general ones
 * when using overlapping path patterns. Here we place both explicitly (one uses /*).
 */
export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Wealth method pages (mounted under /wealth-method/*) */}
      <Route path="/wealth-method/*" element={<WealthMethodRoutes />} />

      {/* Admin dashboard (mounted under /user/*). Declared before the
          catch-all so it takes precedence over HomeRoutes. */}
      <Route path="/user/*" element={<UserRoutes />} />

      {/* Home routes - catch-all for the main site */}
      <Route path="/*" element={<HomeRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
